/**
 * Warning component displayed when a swap would make an account undercollateralized.
 * Used in both PositionAssetSwapDialog and EvcAssetSwapDialogContent.
 */

export function UndercollateralizedWarning() {
  return (
    <div className="rounded-lg border border-red-500/20 bg-red-500/10 p-3 text-red-400 text-sm">
      <p className="font-medium">Cannot swap - account would become undercollateralized</p>
      <p className="mt-2 text-xs opacity-75">To perform this swap, you can:</p>
      <ul className="mt-1 list-inside list-disc text-xs opacity-75">
        <li>Repay some of your borrows first</li>
        <li>Add more collateral from another source</li>
        <li>Swap a smaller amount</li>
      </ul>
    </div>
  )
}
